import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, CanLoad, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from "@angular/router";
import { Observable, of } from "rxjs";
import { filter, map, take, tap } from "rxjs/operators";
import { AppRedirectGuardOptions } from "./AppRedirectGuardOptions";
import { AuthService } from "./Auth/AuthService";

@Injectable()
export class AppRedirectGuard implements CanActivate, CanLoad {
    constructor(
        private authService: AuthService,
        private router: Router) {}

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        const guardOptions = route.data["guardOptions"] as AppRedirectGuardOptions;
        return this.authorizeRoute(guardOptions);
    }

    public canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> {
        const guardOptions = route.data["guardOptions"] as AppRedirectGuardOptions;
        return this.authorizeRoute(guardOptions);
    }

    private authorizeRoute(guardOptions: AppRedirectGuardOptions): Observable<boolean> {
        return this.authService
            .authContext
            .pipe(
                filter(authContext => !!authContext),
                take(1),
                map(authContext => {
                    return authContext.isAuthenticated == guardOptions.isAuthenticated;
                }),
                tap(authorized => {
                    if (!authorized) {
                        if (guardOptions.isAuthenticated) {
                            this.router.navigate(["/login"]);
                        }
                        else {
                            this.router.navigate(["/profile"]);
                        }
                    }
                }))
    }
}
